import { createSelector } from '@ngrx/store';

import { externalBuyerMappingsFeature } from '../reducers/external-buyer-mappings.reducer';

export const {
  selectExternalBuyerMappingsState,
  selectUploadStatus,
  selectUploadSuccessCount,
  selectUploadError,
  selectDownloadStatus,
  selectDownloadError,
} = externalBuyerMappingsFeature;

export const selectIsUploadLoading = createSelector(
  selectUploadStatus,
  (status) => status === 'loading',
);

export const selectIsUploadSuccess = createSelector(
  selectUploadStatus,
  (status) => status === 'success',
);

export const selectIsDownloadLoading = createSelector(
  selectDownloadStatus,
  (status) => status === 'loading',
);
